import { Descriptions, Empty, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import type {
  FailedMessage,
  ParsingError,
} from "../../../services/client/types.gen";

const prettyPrint = (payload: string) => {
  try {
    return JSON.stringify(JSON.parse(payload), null, 2);
  } catch {
    return payload;
  }
};

const parsingErrorColumns: ColumnsType<ParsingError> = [
  {
    title: "Field",
    dataIndex: "location",
    key: "location",
    width: "40%",
    render: (location: string) => (
      <Typography.Text code>{location}</Typography.Text>
    ),
  },
  { title: "Problem", dataIndex: "message", key: "message" },
];

export const FailedMessageDetails = ({
  failedMessage,
}: {
  failedMessage: FailedMessage;
}) => (
  <div className="grid gap-4 xl:grid-cols-2">
    <div>
      <Typography.Text type="secondary">Message we received</Typography.Text>
      {failedMessage.payload ? (
        <pre className="mt-1 max-h-80 overflow-auto rounded bg-gray-50 p-3 text-xs whitespace-pre-wrap break-all">
          {prettyPrint(failedMessage.payload)}
        </pre>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No payload was stored"
        />
      )}
    </div>

    <div>
      <Typography.Text type="secondary">Why we rejected it</Typography.Text>
      {failedMessage.parsing_errors.length > 0 ? (
        <Table<ParsingError>
          className="mt-1"
          size="small"
          columns={parsingErrorColumns}
          dataSource={failedMessage.parsing_errors}
          pagination={false}
          rowKey={(parsingError) =>
            `${parsingError.location}:${parsingError.message}`
          }
        />
      ) : failedMessage.error ? (
        <pre className="mt-1 max-h-80 overflow-auto rounded bg-gray-50 p-3 text-xs whitespace-pre-wrap break-all">
          {failedMessage.error}
        </pre>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No error detail was stored"
        />
      )}
    </div>

    {failedMessage.topic && (
      <Descriptions size="small" column={1} className="xl:col-span-2">
        <Descriptions.Item label="Topic">
          <Typography.Text code>{failedMessage.topic}</Typography.Text>
        </Descriptions.Item>
      </Descriptions>
    )}
  </div>
);
